const actions = {
  getListagemRequisicao: async (
    context,
    {
      unidadeId,
      page,
      perPage,
      criadoEm,
      solicitanteNome,
      ccDescricao,
      voucherId,
      reserva,
      localizacao,
      deposito,
      desmembrado,
      solicitanteTurnoId,
      solicitanteTurno,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/transferencia-estoque/vouchers/listagem`, {
      params: {
        unidadeId,
        page,
        perPage,
        criadoEm,
        solicitanteNome,
        ccDescricao,
        voucherId,
        reserva,
        localizacao,
        deposito,
        desmembrado,
        solicitanteTurnoId,
        solicitanteTurno,
      },
    });

    return res;
  },

  getListagemRequisicaoABB: async (
    context,
    {
      unidadeId,
      page,
      perPage,
      criadoEm,
      solicitanteNome,
      ccDescricao,
      voucherId,
      reserva,
      localizacao,
      deposito,
      desmembrado,
      solicitanteTurnoId,
      solicitanteTurno,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(
      `/transferencia-estoque/vouchers/listagem/por-categoria-do-produto`,
      {
        params: {
          unidadeId,
          page,
          perPage,
          criadoEm,
          solicitanteNome,
          ccDescricao,
          voucherId,
          reserva,
          localizacao,
          deposito,
          desmembrado,
          solicitanteTurnoId,
          solicitanteTurno,
        },
      }
    );

    return res;
  },

  iniciarPicking: async (
    context,
    { unidadeIdOrigem, unidadeIdDestino, usuarioId, observacao, itens }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.post(`/transferencia-estoque/picking`, {
      unidadeIdDestino,
      unidadeIdOrigem,
      usuarioId,
      observacao,
      itens,
    });

    return res;
  },

  finalizarPicking: async (
    context,
    {
      id,
      transportadorId,
      separadorId,
      solicitanteId,
      unidadeIdOrigem,
      editarQuantidades,
      descricao,
      observacao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.put(`/transferencia-estoque/picking/${id}/finalizar`, {
      transportadorId,
      separadorId,
      solicitanteId,
      unidadeIdOrigem,
      editarQuantidades,
      descricao,
      observacao,
    });

    return res;
  },

  getListagemPickings: async (
    context,
    {
      vendor_id,
      page,
      perPage,
      unidadeIdOrigem,
      unidadeIdDestino,
      status,
      dataCriacao,
      dataFinalizacao,
      numero,
      pickingUuid,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/transferencia-estoque/pickings`, {
      params: {
        vendor_id,
        page,
        perPage,
        unidadeIdOrigem,
        unidadeIdDestino,
        status,
        dataCriacao,
        dataFinalizacao,
        numero,
        pickingUuid,
      },
    });

    return res;
  },

  getListagemPickingsAgrupado: async (
    context,
    {
      vendor_id,
      page,
      perPage,
      unidadeIdOrigem,
      unidadeIdDestino,
      status,
      dataCriacao,
      dataFinalizacao,
      numero,
      pickingUuid,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/transferencia-estoque/pickings/itens-agrupados`, {
      params: {
        vendor_id,
        page,
        perPage,
        unidadeIdOrigem,
        unidadeIdDestino,
        status,
        dataCriacao,
        dataFinalizacao,
        numero,
        pickingUuid,
      },
    });

    return res;
  },

  getListagemPickingsABB: async (
    context,
    {
      vendor_id,
      page,
      perPage,
      unidadeIdOrigem,
      unidadeIdDestino,
      status,
      dataCriacao,
      dataFinalizacao,
      numero,
      pickingUuid,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/transferencia-estoque/pickings/por-categoria`, {
      params: {
        vendor_id,
        page,
        perPage,
        unidadeIdOrigem,
        unidadeIdDestino,
        status,
        dataCriacao,
        dataFinalizacao,
        numero,
        pickingUuid,
      },
    });

    return res;
  },

  getListagemPicking: async (
    context,
    { vendor_id, pickingUuid, voucherId, deposito, centro, lote, reserva }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(
      `/transferencia-estoque/picking/${pickingUuid}/detalhe`,
      {
        params: {
          vendor_id,
          pickingUuid,
          voucherId,
          deposito,
          centro,
          lote,
          reserva,
        },
      }
    );

    return res;
  },

  getTransferencia: async (context, { numero }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/transferencia-estoque`, {
      params: {
        numero,
      },
    });

    return res;
  },

  enviarPicking: async (
    context,
    { numero, auth_type, auth_content, usuario_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.put(`/transferencia-estoque/picking/${numero}/enviar`, {
      auth_type,
      auth_content,
      usuario_id,
    });

    return res;
  },

  receberPicking: async (
    context,
    { numero, auth_type, auth_content, usuario_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.put(
      `/transferencia-estoque/picking/${numero}/receber`,
      {
        auth_type,
        auth_content,
        usuario_id,
      }
    );

    return res;
  },

  getCentrosCustos: async (context, { vendor_id, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/cost-centers`, {
      params: {
        per_page: 8,
        vendor_id,
        search,
      },
    });

    return response;
  },
  getControlePicking: async (
    context,
    { unidadeId, voucherId, reservaId, pickingNumero, dataInicial, dataFinal }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/transferencia-estoque/listagem/controle-temporal/export`,
      {
        params: {
          unidadeId,
          voucherId,
          reservaId,
          pickingNumero,
          dataInicial,
          dataFinal,
        },
      }
    );

    return response;
  },

  getControlePickingABB: async (
    context,
    { unidadeId, voucherId, reservaId, pickingNumero, dataInicial, dataFinal }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/transferencia-estoque/listagem/controle-temporal/export/por-categoria-do-produto`,
      {
        params: {
          unidadeId,
          voucherId,
          reservaId,
          pickingNumero,
          dataInicial,
          dataFinal,
        },
      }
    );

    return response;
  },
  cancelarPicking: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `/transferencia-estoque/picking/${id}/cancelar`
    );

    return response;
  },

  getListagemIntegracao: async (
    context,
    {
      per_page,
      page,
      unidade_id,
      data_inicial,
      data_final,
      com_erro,
      operacao,
      voucher_id,
      numero_reserva,

      solicitante,
      produto,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/integracao/reserva/operacoes`, {
      params: {
        page,
        unidade_id,
        data_inicial,
        data_final,
        com_erro,
        operacao,
        voucher_id,
        numero_reserva,
        solicitante,

        produto,

        per_page,
      },
    });

    return res;
  },
  exportarListagemIntegracao: async (
    context,
    {
      unidade_id,
      data_inicial,
      data_final,
      com_erro,
      operacao,
      voucher_id,
      numero_reserva,
      solicitante,

      produto,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/integracao/reserva/operacoes/export`, {
      params: {
        unidade_id,
        data_inicial,
        data_final,
        com_erro,
        operacao,
        voucher_id,
        numero_reserva,
        solicitante,

        produto,
      },
    });

    return res;
  },

  reenviarListagemIntegracao: async (context, { voucherId, productId }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(
      `/integracao/reserva/${voucherId}/${productId}/reprocessar`
    );

    return res;
  },

  getHistoricoPicking: async (context, { voucherId }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `transferencia-estoque/picking/historico/${voucherId}`
    );

    return response;
  },
};

export const pkg = {
  namespaced: true,
  actions,
};
